// import '../../App.scss';
import Divider from '../Atoms/Divider';
import BoxDivider from '../Atoms/BoxDivider';
import Card from '../Molecules/Card';
import React, { useState, Component } from 'react';
import CardSlider from './CardSlider';
import ChipSection from '../Molecules/ChipSection'
import CardScroll from './CardScroll';


class CuratedSection extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   example: someInfo,
    // };
  }
  

  render() {
    

    return (
      <div className="flex wrap"> 
        {/* <Divider width="100" height="9" content="KURATEREDE UDSTILLINGER" cx="hidden flex items-bottom bb"/>  */}
        <Divider width="100" height="9" content="Kuraterede udstillinger" cx="uppercase hidden flex items-bottom bb phone-h-15 sticky-top bg z-1" icon="🎤"/>
        
        <div className="w-100 max-h-90 flex phone-max-150">
          <BoxDivider cx="w-5 phone-w-10" horisontal={false}/>
          <CardScroll cx="w-90 flex wrap justify-around br bb bl hidden-horisontal scroll-vertical no-scroll-bar" cardCx=""/>
          <BoxDivider cx="w-5 phone-w-10" horisontal={false}/>
        </div>


        <div className="w-100">
          <BoxDivider horisontal={true}/>
        </div>
        
      </div>
    
    );
  }
}


export default CuratedSection;



// {/* <div className="w-100">
//           <ChipSection />
//         </div>